export default "__VITE_ASSET__deb82725__"